import { ITypedReduxAction } from 'shared/map-search/types/redux/actionType';

export enum EMlSearchSessionGuidActionType {
  Set = 'mlSearchSessionGuid/set',
}

export type TSetMlSearchSessionGuidAction = ITypedReduxAction<EMlSearchSessionGuidActionType.Set, string | null>;
export type TMlSearchSessionGuidActions = TSetMlSearchSessionGuidAction;
